import { type ReactNode } from 'react';
import { Callout as RadixCallout } from '@radix-ui/themes';

export interface CalloutProps extends React.ComponentProps<typeof RadixCallout.Root> {
  children: ReactNode;
}

/** Thin wrapper over the Radix callout: soft variant with body-size text. */
export function Callout({ children, ...props }: CalloutProps) {
  return (
    <RadixCallout.Root {...props}>
      <RadixCallout.Text size={props.size}>{children}</RadixCallout.Text>
    </RadixCallout.Root>
  );
}
